import "core-js/modules/es.array.includes.js";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";
import Alerts from "@/components/alerts.vue";
import Translations from "./components/translations.vue";
import MainModal from "./components/elements/main-modal.vue";
import ImpersonationBar from "./components/elements/impersonation-bar.vue";
import PasswordExpiryGate from "./components/elements/password-expiry-gate.vue";
import IdleLogout from "./components/elements/idle-logout.vue";
import TenantAccessPrompt from "./components/elements/tenant-access-prompt.vue";
import { SUPPORTED_LOCALES } from "@/translations/supported";
import { isEmbedded } from "@/utils/embed";
export default {
  name: "XmedApp",
  components: {
    MainModal,
    Translations,
    Alerts,
    ImpersonationBar,
    PasswordExpiryGate,
    IdleLogout,
    TenantAccessPrompt
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'user/authenticated',
      translations: 'trans/translations',
      aliases: 'trans/aliases',
      locale: 'trans/locale',
      configuration: 'app/configuration',
      translationsLoaded: 'trans/loaded'
    }),
    // a keret-mód a betöltéskor dől el (a beváltó cím vagy a fül tárolója), menet közben nem változik
    embedded: () => isEmbedded()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler: function (user) {
        if (this.authenticated && !user?.id) {
          console.log('user', this.authenticated, user);
          this.$store.dispatch('user/authenticated');
        }
        this.applySavedLocale(user);
      }
    },
    authenticated: {
      immediate: true,
      deep: true,
      handler: function (authenticated) {
        if (authenticated && !this.user?.id) {
          console.log('authenticated', authenticated, this.user);
          this.$store.dispatch('user/authenticated');
        }
      }
    }
  },
  data() {
    return {
      // ⚠️ Aki mentett nyelvvel érkezik, annak SOHA nem írunk vissza. A figyelő a
      // tárolóból visszaállított, ELAVULT felhasználóval is lefut (ugyanabban a
      // böngészőben a második belépéskor), és egy visszaírás ott a régi nyelvvel
      // felülírná a frisset — megmérve pontosan ez történt. Ez a jelző csak azt
      // őrzi, hogy akinek nincs nyelve, annak egyszer állítsunk be egyet.
      localeWritten: false
    };
  },
  created() {
    console.log(this.$router);
  },
  methods: {
    /**
     * A belépő MENTETT nyelvén induljon a felület.
     *
     * A nyelvváltó eddig is elmentette a választást (`users.locale`), csak senki nem
     * olvasta vissza: minden betöltéskor az alapnyelven indult a felület, akármit
     * választott a felhasználó legutóbb. A választás megmaradt az adatbázisban, de
     * sehol nem látszott.
     *
     * ⚠️ A SORREND itt a lényeg, és emiatt nem küld nyelvet a belépés (`auth/login`):
     * a nyelv-végpont a munkamenet mellett a felhasználó SORÁBA is ír, tehát a
     * belépéskor kiküldött alapértelmezés felülírta a korábban választott nyelvet.
     * Innentől a tárolt nyelv nyer, és a kliens csak akkor ír, ha van mit.
     *
     * ⚠️ Csak TÁMOGATOTT nyelvre váltunk. Egy időközben kivezetett vagy elgépelt érték
     * a soron maradhat, és arra váltva a felület nyers kulcsokat mutatna — a rossz
     * adat nem érhet többet, mint az alapértelmezés.
     */
    applySavedLocale(user) {
      if (!user?.id) {
        return;
      }
      const saved = (user.locale || '').toLowerCase();
      if (saved && SUPPORTED_LOCALES.includes(saved)) {
        if (saved !== this.locale) {
          // A váltás maga viszi tovább a szerverre is (`translations.vue` figyelője).
          this.$store.dispatch('trans/locale', saved);
        }
        return;
      }

      // Idáig csak az jut el, akinek NINCS mentett nyelve: neki a mostani választás
      // lesz az első. Egyszer írunk, mert a figyelő a felhasználó minden változására
      // újrafutna.
      if (!this.localeWritten) {
        this.localeWritten = true;
        this.$store.dispatch('trans/setLocale');
      }
    }
  }
};